interface Link {
    target?: string;
    text?: string;
    url: string;
}

export interface Links {
    redirectURL: Link;
    overview: Link;
    aboutSavingInfo: Link;
    overviewOfSavingInfo: Link;
    howToCreateInfo: Link;
    enterApproverParentInformation: Link;
    applicantParentSummary: Link;
    applicantParentSuccess: Link;
    applicantParentStop: Link;
    nextStep: Link;
    process: Link;
    approverParentConsent: Link;
    approverParentSuccess: Link;
    mobileAndOnlineBank: Link;
    affectsScholarship: Link;
    lanekassenWealthRules: Link;
    governorInvolvement: Link;
    smartspar: Link;
    eit: Link;
    portefolje: Link;
    onlineBank: Link;
}

export const links: Links = {
    redirectURL: {
        url: 'https://www.eikakapitalforvaltning.no',
    },
    overview: {
        url: '/',
    },
    aboutSavingInfo: {
        url: '/om-sparing-i-barnets-navn',
    },
    overviewOfSavingInfo: {
        url: '/oversikt-over-sparing',
    },
    howToCreateInfo: {
        url: '/slik-oppretter-du',
    },
    enterApproverParentInformation: {
        url: '/medforelder-informasjon',
    },
    applicantParentSummary: {
        url: '/oppsummering',
    },
    applicantParentSuccess: {
        url: '/suksess',
    },
    applicantParentStop: {
        url: '/stopp',
    },
    nextStep: {
        url: '/next-step',
    },
    process: {
        url: '/prosess',
    },
    approverParentConsent: {
        url: '/prosess/:processId/samtykke',
    },
    approverParentSuccess: {
        url: '/medforelder-suksess',
    },
    mobileAndOnlineBank: {
        url: '/dagligbank/mobilbank-nettbank',
    },
    affectsScholarship: {
        url: '/sparing-og-pensjon/fond/aksjesparekonto/aksjesparekonto-i-barnets-navn/stipend',
    },
    lanekassenWealthRules: {
        url: 'https://lanekassen.no/nb-NO/stipend-og-lan/inntekt-og-formue/',
    },
    governorInvolvement: {
        url: '/sparing-og-pensjon/fond/aksjesparekonto/aksjesparekonto-i-barnets-navn/statsforvalter',
    },
    smartspar: { url: '/sparing-og-pensjon/fond/smartspar' },
    eit: { url: 'https://www.eikakapitalforvaltning.no/EIT/' },
    portefolje: { url: '/nettbank/sparing#/portefolje' },
    onlineBank: { url: '/nettbank' },
};
